import { IconButton, Tooltip, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import BackIcon from '@mui/icons-material/ArrowBack';

interface BackNavigationProps {
  title?: string;
}
export const BackNavigation = ({ title }: BackNavigationProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      {location && location.key !== 'default' && (
        <IconButton className="btn btn-goBack" aria-label="back" onClick={goBack}>
          <Tooltip title={title ? title : 'Go Back'}>
            <BackIcon />
          </Tooltip>
        </IconButton>
      )}
    </>
  );
};
